<template lang="pug">
    div.aboutUpdate(v-if="dataLoaded" :class='{updating:updating!==null}')
        section.weDo.doJoin
            .bg
            .container
                .content
                    .left
                        .title.updateMe(data-updating="doJoin_title")
                            div(v-html="aboutContent.doJoin_title.content")
                        .strip
                        .text.updateMe(data-updating="doJoin_text")
                            div(v-html="aboutContent.doJoin_text.content")
                    .right
                        div

        section.weDo.doProjects
            .decor.d1
            .decor.d2
            .decor.d3
            .decor.d4
            .container
                .content
                    .left
                        .title.updateMe(data-updating="doProjects_title")
                            div(v-html="aboutContent.doProjects_title.content")
                        .strip
                        .text.updateMe(data-updating="doProjects_text")
                            div(v-html="aboutContent.doProjects_text.content")
                        .watchCase.updateMe(data-updating="doProjects_link")
                            router-link.play(:to="{name:'case',params:{id:aboutContent.doProjects_link.content}}")
                            span смотреть кейс
                    .right
                        .absolute.updateMe(data-updating="doProjects_img")
                            div.img(:style="{backgroundImage:updating&&updating.name==='doProjects_img'&&tempFile?'url('+tempFile+')':'url('+$rootPath+'/backend/img/aboutContent/'+aboutContent.doProjects_img.content+')'}")


        section.weDo.doResult
            .decor.d1
            .decor.d2
            .decor.d3
            .decor.d4
            .container
                .content
                    .left
                        .title.updateMe(data-updating="doResult_title")
                            div(v-html="aboutContent.doResult_title.content")
                        .strip
                        .text.updateMe(data-updating="doResult_text")
                            div(v-html="aboutContent.doResult_text.content")
                        .watchCase.updateMe(data-updating="doResult_link")
                            router-link.play(:to="{name:'case',params:{id:aboutContent.doResult_link.content}}")
                            span смотреть кейс
                    .right
                        .absolute.updateMe(data-updating="doResult_img")
                            div.img(:style="{backgroundImage:updating&&updating.name==='doResult_img'&&tempFile?'url('+tempFile+')':'url('+$rootPath+'/backend/img/aboutContent/'+aboutContent.doResult_img.content+')'}")
                        .statistic.updateMe(data-updating="doResult_stats")
                            .stat
                                .big(v-html="aboutContent.doResult_stats.content.stat1.big")
                                small(v-html="aboutContent.doResult_stats.content.stat1.small")
                            .stat
                                small(v-html="aboutContent.doResult_stats.content.stat2.small")
                                .big(v-html="aboutContent.doResult_stats.content.stat2.big")
                            .stat
                                small(v-html="aboutContent.doResult_stats.content.stat3.small")
                                .big(v-html="aboutContent.doResult_stats.content.stat3.big")
                            .stat
                                .big(v-html="aboutContent.doResult_stats.content.stat4.big")
                                small(v-html="aboutContent.doResult_stats.content.stat4.small")

        section.weDo.doSplitExp
            .container
                .content
                    .left
                        .title.updateMe(data-updating="doSplitExp_title")
                            div(v-html="aboutContent.doSplitExp_title.content")
                        .strip
                        .text.updateMe(data-updating="doSplitExp_text")
                            div(v-html="aboutContent.doSplitExp_text.content")
                    .right
                        .articlesLinks
                            .link(v-for="(link, ind) in aboutContent.doSplitExp_linkList.content" :key="ind")
                                span(v-html="link.span")
                                a(:href="link.a" target="_blank" v-html="link.name")
                                .deleteBtn(@click='deleteLink(ind)' title='Удалить')
                            a.addNewLink(@click="addNewLink()") Добавить ссылку

        .updatingForm(ref="updatingForm" v-if="updating!==null"  :class="{'stats':updating.type==='stats'}")
            .row
                form(@submit.prevent='')
                    .file-field.input-field.col.s12.formFile(v-if="updating.type==='img'")
                        .btn.orange.darken-2
                            span Изображение
                            input(type='file' @change="showFile($event.target.files[0])")
                            small.helper-text.invalid(v-if='formError') {{formError}}
                        .file-path-wrapper
                            input.file-path.validate(type='text')
                    .row.col.s12(v-else-if="updating.type==='stats'")
                        .statBlock
                            .input-field
                                textarea.materialize-textarea(data-length='120' v-model="updating.content.stat1.big")
                            .input-field
                                textarea.materialize-textarea(data-length='120' v-model="updating.content.stat1.small")
                        .statBlock
                            .input-field
                                textarea.materialize-textarea(data-length='120' v-model="updating.content.stat2.small")
                            .input-field
                                textarea.materialize-textarea(data-length='120' v-model="updating.content.stat2.big")

                        .statBlock
                            .input-field
                                textarea.materialize-textarea(data-length='120' v-model="updating.content.stat3.small")
                            .input-field
                                textarea.materialize-textarea(data-length='120' v-model="updating.content.stat3.big")
                        .statBlock
                            .input-field
                                textarea.materialize-textarea(data-length='120' v-model="updating.content.stat4.big")
                            .input-field
                                textarea.materialize-textarea(data-length='120' v-model="updating.content.stat4.small")
                    .row.col.s12(v-else)
                        .input-field
                            textarea#title.materialize-textarea(data-length='120' v-model="updating.content")
                            label(for='title') Текст
                    .row
                        button.col.s5.btn.waves-effect.waves-light.orange.darken-2(type='submit' name='action' @click="cancleUpdate()") Отмена
                            i.material-icons.right cancel
                        button.col.s5.offset-s2.btn.waves-effect.waves-light.orange.darken-2(type='submit' name='action' @click="saveUpdate()") Сохранить
                            i.material-icons.right save

        .addLinkForm(v-if="addingLink!==null")
            .row
                form(@submit.prevent='')
                    .row.col.s12()
                        .input-field
                            textarea#linkTitle.materialize-textarea(data-length='120' v-model="addingLink.span")
                            label(for='linkTitle') Текст ссылки
                        .input-field
                            textarea#linkName.materialize-textarea(data-length='120' v-model="addingLink.name")
                            label(for='linkName') Имя ссылки
                        .input-field
                            textarea#linkA.materialize-textarea(data-length='120' v-model="addingLink.a")
                            label(for='linkA') Ссылка
                    .row
                        button.col.s5.btn.waves-effect.waves-light.orange.darken-2(type='submit' name='action' @click="cancleAddLink()") Отмена
                            i.material-icons.right cancel
                        button.col.s5.offset-s2.btn.waves-effect.waves-light.orange.darken-2(type='submit' name='action' @click="saveLink()") Сохранить
                            i.material-icons.right save
</template>

<script>
    import materialize from 'materialize-css/dist/js/materialize.min'

    export default {
        name: "AboutUpdate",
        data: () => ({
            updating: null, // Обновляемый в данный момент объект
            updatingCopy: null, // Копия для отмены
            aboutContent: {},
            dataLoaded: false,
            formError: '',
            tempFile: null, //Временный файл для показа изображения
            loadedImg: null, //Загруженное изображение

            addingLink: null, //Новая ссылка
        }),
        async mounted() {
            await this.fetchContent();
            this.addUpdateBtns();
        },
        methods: {
            addUpdateBtns() {
                let updateMe = document.querySelectorAll('.updateMe');
                Array.prototype.forEach.call(updateMe, (el) => {
                    let updateButton = document.createElement('div');
                    updateButton.classList.add('updateButton');
                    updateButton.addEventListener('click', this.updateClick);
                    el.appendChild(updateButton);
                })
            },
            updateClick(e) {
                let parent = e.target.closest('.updateMe');
                this.updating = this.aboutContent[parent.getAttribute('data-updating')];
                this.updatingCopy = JSON.parse(JSON.stringify(this.updating));
                setTimeout(() => {
                    parent.appendChild(this.$refs.updatingForm);
                    M.updateTextFields();
                })
            },


            addNewLink() {
                this.addingLink = {span: '', a: '',name: ''};
                console.log(this.addingLink);
            },
            cancleAddLink() {
                this.addingLink = null;
            },
            async saveLink(action, ind) {
                if (action=='remove' && ind!==undefined){
                    this.aboutContent.doSplitExp_linkList.content.splice(ind,1);
                } else{
                    this.aboutContent.doSplitExp_linkList.content.push(this.addingLink);
                }
                let data = this.compileFormData({
                    action: 'updateAboutContent',
                    id: this.aboutContent.doSplitExp_linkList.id,
                    type: this.aboutContent.doSplitExp_linkList.type,
                    content: JSON.stringify(this.aboutContent.doSplitExp_linkList.content)
                });
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                console.log(responseData);
                if (!responseData.error && responseData.success) {
                    this.addingLink = null;
                } else {
                    this.formError = responseData.message;
                    console.log(responseData);
                }
            },
            deleteLink(ind){
                this.saveLink('remove',ind)
            },


            cancleUpdate() {
                this.aboutContent[this.updating.name] = JSON.parse(JSON.stringify(this.updatingCopy));
                this.clearForm();
            },
            async saveUpdate() {
                let data = this.compileFormData({
                    action: 'updateAboutContent',
                    id: this.updating.id,
                    type: this.updating.type,
                    content: this.updating.type === 'img' ? this.loadedImg
                        : this.updating.type === 'stats' ? JSON.stringify(this.updating.content)
                            : this.updating.content
                });
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                console.log(responseData);
                if (!responseData.error && responseData.success) {
                    if (responseData.newImgName) {
                        this.updating.content = responseData.newImgName;
                    }
                    this.clearForm();
                } else {
                    this.formError = responseData.message;
                    console.log(responseData);
                }

            },
            clearForm() {
                this.updating = null;
                this.updatingCopy = null;
                this.tempFile = null;
                this.loadedImg = null;
                this.formError = '';
            },
            showFile(f) {
                this.loadedImg = f;
                if (!f.type.match('image.*')) return;
                var fr = new FileReader();
                fr.onload = (() => (e) => {
                    this.tempFile = e.target.result;
                })(f);
                fr.readAsDataURL(f);
            },
            async fetchContent() {
                let data = this.compileFormData({action: 'fetchAboutContent',})
                let response = await fetch(this.$rootPath + '/backend/app/', {
                    method: 'POST',
                    body: data,
                });
                let responseData = await response.json();
                if (!responseData.error) {
                    let aboutContent = {};
                    responseData.content.forEach(el => {
                        let {name, ...params} = el;
                        aboutContent[name] = {name, ...params};
                    });
                    this.aboutContent = aboutContent;
                    this.aboutContent.doSplitExp_linkList.content = JSON.parse(this.aboutContent.doSplitExp_linkList.content);
                    this.aboutContent.doResult_stats.content = JSON.parse(this.aboutContent.doResult_stats.content);
                    this.dataLoaded = true;
                } else {
                    console.log(responseData);
                }
            },
            compileFormData(data) {
                let formData = new FormData();
                for (let pr in data) {
                    formData.append(pr, data[pr]);
                }
                return formData;
            },
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/_functions.scss";

    .aboutUpdate {
        &.updating .updateMe .updateButton {
            display: none;
        }

        section.weDo {
            position: relative;
            height: 100vh;
            background: no-repeat center center / cover;
            color: #000;

            .bg {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
            }

            &.doJoin {
                .bg {
                    background-color: #fff2d2;
                }

                .content {
                    .left {
                        padding: 11% 0 10%;
                    }

                    .right {
                        flex-basis: 66%;

                        div {
                            width: 100%;
                            height: 100%;
                            transform: translate(2.5%, -0.5%);
                            background: url(../../assets/img/about/weDo-join.png) no-repeat center right / 88% auto;
                        }
                    }
                }
            }

            &.doProjects {
                overflow: hidden;

                .decor {
                    position: absolute;
                    background: no-repeat center center / contain;
                    z-index: -1;
                    top: -28%;
                    left: 16.5%;
                    right: -5.5%;
                    bottom: -21%;

                    &.d1 {
                        background-image: url(../../assets/img/about/decor/doProjects_bg-1.svg);
                    }

                    &.d2 {
                        background-image: url(../../assets/img/about/decor/doProjects_bg-2.svg);
                    }

                    &.d3 {
                        background-image: url(../../assets/img/about/decor/doProjects_bg-3.svg);
                    }

                    &.d4 {
                        background-image: url(../../assets/img/about/decor/doProjects_bg-4.svg);
                    }
                }
            }

            &.doResult {
                background-color: #e9faff;
                overflow: hidden;

                .decor {
                    position: absolute;
                    background: no-repeat center center / 100% 100%;

                    &.d1 {
                        top: 0;
                        left: 29.3%;
                        right: 0;
                        bottom: 0;
                        background-image: url(../../assets/img/about/decor/doResult_bg-1.svg);
                    }

                    &.d2 {
                        top: 3%;
                        left: 39.1%;
                        right: 8.6%;
                        bottom: 0%;
                        background-image: url(../../assets/img/about/decor/doResult_bg-2.svg);
                    }

                    &.d3 {
                        top: 21%;
                        left: 48.8%;
                        right: 18.3%;
                        bottom: 17.8%;
                        background-image: url(../../assets/img/about/decor/doResult_bg-3.svg);
                    }

                    &.d4 {
                        top: 36%;
                        left: 58%;
                        right: 27.5%;
                        bottom: 35%;
                        background-image: url(../../assets/img/about/decor/doResult_bg-4.svg);
                    }
                }

                .content {
                    margin-top: 6.5%;

                    .left {
                        flex-basis: 28%;
                        padding: 0;

                        .title {
                            margin-bottom: 3.5rem;
                        }
                    }

                    .right {
                        flex-basis: 48.9%;
                        flex-direction: column;

                        .absolute {
                            width: 91.5%;
                            margin-right: 8.2%;
                            margin-top: 0.5%;
                            margin-bottom: 5.8rem;

                            div.img {
                                width: 100%;
                                padding-top: 51.5%;
                            }
                        }

                        .statistic {
                            display: flex;
                            flex-wrap: wrap;

                            .stat {
                                width: 45.5%;
                                margin-bottom: 2.3rem;
                                line-height: to_rem(23px);

                                .big {
                                    font-size: to_rem(22px);
                                }

                                small {
                                    font-size: to_rem(16px);
                                }
                            }
                        }
                    }
                }
            }

            &.doSplitExp {
                background-image: url(../../assets/img/about/weDo-splitExp-bg.jpg);

                .content {
                    .left {
                        padding: 11% 0 0;

                        .title {
                            margin-bottom: 3.2rem;
                        }
                    }

                    .right {
                        height: 40rem;
                        justify-content: flex-start;
                        flex-basis: 48.4%;

                        .articlesLinks {
                            width: 30.8rem;
                            max-width: 90%;
                            max-height: 100%;
                            overflow: auto;

                            #mCSB_1_scrollbar_vertical .mCSB_dragger {
                                height: to_rem(20px) !important;
                                min-height: initial;
                                background-color: #ffc819;
                                width: to_rem(20px);
                                border-radius: 50%;
                            }

                            .mCSB_scrollTools {
                                width: to_rem(20px);
                            }

                            .mCSB_scrollTools .mCSB_draggerRail {
                                width: 1px;
                                background: #bfccb1;
                            }

                            .mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
                                display: none;
                            }

                            .link {
                                position: relative;
                                max-width: 87%;
                                font-size: to_rem(16px);
                                line-height: to_rem(32px);
                                padding: 1rem 0 1.6rem;

                                &:not(:last-child) {
                                    border-bottom: 1px solid #d7e6c7;
                                }
                                .deleteBtn{
                                    position: absolute;
                                    top: 0;
                                    right: 0;
                                    height: 2rem;
                                    width: 2rem;
                                    background: url(../../assets/img/admin/delete-icon.png) no-repeat center center/contain;
                                    display: none;
                                    cursor: pointer;
                                }

                                &:hover {
                                    span, a {
                                        color: #000;
                                    }
                                    .deleteBtn{
                                        display: block;
                                    }
                                }

                                a:hover {
                                    text-decoration: underline;
                                }

                                span, a {
                                    color: #7c7c7c;
                                }

                                span {
                                    display: block;
                                    user-select: none;
                                }
                            }

                            a.addNewLink {
                                float: right;
                                margin: 2rem 2rem 1rem;
                                font-size: 1.3rem;
                                font-weight: 500;
                                color: #f57c00;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }

            .container {
                height: 100%;
                max-width: 1170px;
                display: flex;
                align-items: center;
                padding: 0 35px;
            }

            .content {
                width: 100%;
                display: flex;
                justify-content: space-between;

                .left {
                    flex-basis: 34%;
                    padding: 13.4% 0 0;

                    .title {
                        margin-bottom: 4.2rem;
                        font: 900 to_rem(30px)/to_rem(36px) Geometria;
                        letter-spacing: to_rem(1px);
                    }

                    .strip {
                        width: 4.14rem;
                        height: to_rem(5px);
                        margin-bottom: 2.4rem;
                        margin-left: -2px;
                        background: #000;
                    }

                    .text {
                        margin-bottom: 4.4rem;
                        font: 400 to_rem(16px)/to_rem(24px) Geometria;
                    }
                }

                .right {
                    position: relative;
                    flex-basis: 46.9%;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;

                    .absolute {
                        width: 100%;
                        margin-right: 4.2%;
                        margin-top: -1.2%;

                        div.img {
                            width: 100%;
                            padding-top: 53.9%;
                            background: no-repeat center center / cover;
                            box-shadow: 0 to_rem(22px) to_rem(27px) rgba(0, 0, 0, 0.37);
                        }
                    }
                }

                .watchCase {
                    display: flex;
                    align-items: center;

                    .play {
                        width: 5.14rem;
                        height: 5.14rem;
                        margin-right: 1.43rem;
                        background: url(../../assets/img/about/play.png) no-repeat center center / contain;
                        cursor: url(./../../assets/img/cursor-hover.png) 25 25, pointer;
                    }

                    span {
                        font-size: to_rem(12px);
                    }
                }
            }
        }

        .updateMe {
            position: relative;

            &:hover .updateButton {
                opacity: 1;
            }

            .updateButton {
                position: absolute;
                bottom: 100%;
                right: 0;
                height: 3rem;
                width: 3rem;
                background: url(../../assets/img/admin/update-icon.png) no-repeat center center / contain;
                opacity: 0;
                transition: .5s;
                cursor: pointer;
            }

        }

        .updatingForm, .addLinkForm {
            position: fixed;
            top: 30%;
            left: 50%;
            transform: translateX(-50%);
            z-index: 1;
            width: 32rem;
            background: rgba(255, 255, 255, 0.8);

            &.stats {
                width: 37rem;

                form {
                    display: flex;
                    flex-direction: column;

                    .row {
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        padding: 0;
                    }

                    .statBlock {
                        width: 50%;
                        margin-bottom: 1rem;
                        padding: 5px 10px;
                        border: 1px solid rgba(#f57c00, 0.1);

                        &:nth-of-type(odd) {
                            border-right: 0;
                        }

                        .input-field {
                            margin: 0;
                        }

                        textarea {
                            margin: 0;
                        }
                    }
                }
            }

            form {
                margin: 1rem 1rem 0;

                .formFile {
                    margin-bottom: 3rem;
                    padding: 0 !important;
                }

                small {
                    position: absolute !important;
                    color: red !important;
                    font-size: 1rem !important;
                    font-weight: 400;
                    cursor: url(./../../assets/img/cursor.png) 8 8, auto;
                }

                .row {
                    margin-bottom: 0 !important;
                }

                .input-field {
                    padding: 0;

                    textarea {
                        resize: vertical;
                    }


                    textarea:focus + label {
                        color: $color !important;
                    }

                    textarea:focus {
                        border-bottom: 1px solid $color !important;
                        box-shadow: 0 1px 0 0 $color !important;
                    }
                }

            }

            @import "https://fonts.googleapis.com/icon?family=Material+Icons";
            @import "~materialize-css/sass/materialize";
        }
    }
</style>